import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { LoadingSpinner } from '@/components/shared/ui/LoadingSpinner';
import { useUIStore } from '@/stores/useUIStore';

/**
 * Wrapper component that opens the auth modal for user login
 * Redirects to home when modal is closed
 */
export const UserAuthModalWrapper = () => {
    const navigate = useNavigate();
    const { openAuthModal, isAuthModalOpen } = useUIStore();

    useEffect(() => {
        openAuthModal('login');
    }, [openAuthModal]);

    useEffect(() => {
        if (!isAuthModalOpen) {
            navigate('/');
        }
    }, [isAuthModalOpen, navigate]);

    return <LoadingSpinner size="sm" message="Iniciando sesión..." />;
};
